<div class="tw-flex tw-h-full tw-items-center tw-justify-end">
  <app-category-source-badge [source]="source"></app-category-source-badge>
</div>
